/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Payload de la section « ETAT MATRIMONIAL ANTÉRIEUR » de l'onglet d'un
 * conjoint, envoyé via `service.update`
 * (PUT `/numerisation-actes/mariage/{identifiant}`).
 *
 * Un payload d'ACTE dans la modale d'un INDIVIDU : ces colonnes sont sur
 * `ec_actm` mais s'éditent dans l'onglet du conjoint, c'est de lui qu'il s'agit.
 *
 * ⚠️ Le code est celui du RÉFÉRENTIEL, jamais le vocabulaire interne du Cases du
 * modèle : le repository traduit, et purge ce que la situation n'autorise pas.
 *
 * ⚠️ `dateEtatMatrimonial` est unique côté contrat — le back l'aiguille vers la
 * colonne de divorce, de veuvage ou de Pacs selon le code. D'où le nom préfixé
 * `conjoint{n}DateEtatMatrimonial`, et non un nom de colonne.
 *
 * @param identifiant     Identifiant de l'ACTE : construit l'URL du PUT.
 * @param numeroConjoint  1 ou 2 : de quel conjoint il s'agit.
 * @param data            État du formulaire de la modale.
 */
const buildEtatAnterieurUpdatePayload = (
  identifiant: number,
  numeroConjoint: 1 | 2,
  data: Record<string, any>,
) => {
  const prefixe = `conjoint${numeroConjoint}`;

  return {
    identifiant,
    acte: {
      identifiant,
      [`${prefixe}EtatMatrimonialAnterieureCode`]:
        data?.etatMatrimonialAnterieureCode,
      [`${prefixe}DateEtatMatrimonial`]: data?.dateEtatMatrimonial,
      [`${prefixe}NomExConjoint`]: data?.nomExConjoint,
      [`${prefixe}PrenomExConjoint`]: data?.prenomExConjoint,
    },
  };
};

export default buildEtatAnterieurUpdatePayload;
